// room-url.ts - utilities for building and parsing room URLs.
//
// Re-exports crypto helpers and adds URL construction.

import { generateRoomSecret as genSecret } from './crypto';

export { genSecret as generateRoomSecret };

// Build /r/{roomId}#k={roomSecret}&a={accessToken} URL.
export function buildRoomURL(roomId: string, roomSecret: string, accessToken: string): string {
  const base = `${window.location.origin}/r/${roomId}`;
  return `${base}#k=${encodeURIComponent(roomSecret)}&a=${encodeURIComponent(accessToken)}`;
}
